<template>
  <div class="expected-Delivery-date_apply">
    <CustomerScheduleChangeFilling
      ref="customerScheduleChangeFilling"
      v-loading="isLoading"
      is-apply
      :change-type="changeType"
      @changeCeddType="handleChangeCeddType"
    />
    <!-- 基础信息 -->
    <BasicInformation ref="basicInformation" v-loading="isLoading" is-apply :is-re-submit="Boolean(isReSubmit)" :tatol-cny="tatolCny" />
    <!-- 详细信息 -->
    <DetailedInformation
      ref="detailedInformation"
      v-loading="isLoading"
      :change-type="changeType"
      :verification-date="verificationDate"
      @totalCny="totalCny"
    />
    <!-- 操作记录 -->
    <OperationRecordHistory v-if="isReSubmit" :application-id="applicationId" />
    <!-- 底部按钮 -->
    <BottomButtonGroup :loading="isLoading" is-apply @submit="handleSubmit" @cancel="handleCancel" />
  </div>
</template>

<script>
// 客户变更信息
import CustomerScheduleChangeFilling from '../components/CustomerScheduleChangeFilling/index.vue';
// 基础信息
import BasicInformation from '../components/BasicInformation.vue';
// 详细信息
import DetailedInformation from './components/DetailedInformation.vue';
// 操作记录
import OperationRecordHistory from '@/views/ExpectedDeliveryDate/components/OperationRecordHistory.vue';
// 底部按钮
import BottomButtonGroup from '../components/BottomButtonGroup.vue';
import { mapState } from 'vuex';
import {
  getCeddChangeApplyDetail,
  getCeddChangeDetail,
  submitChangeApply
} from '@/API/international';

/**
 * 商务提交时申请
 */
export default {
  name: 'Apply',
  components: {
    BottomButtonGroup,
    DetailedInformation,
    BasicInformation,
    CustomerScheduleChangeFilling,
    OperationRecordHistory
  },
  data () {
    return {
      contractNum: '', // 合同编号
      applicationId: '', // 申请单单号
      isReSubmit: 0, // 是否是重新提交
      changeType: '', // 变更类型
      isLoading: false,
      verificationDate: '', // T+7的日期
      tatolCny: 0
    };
  },
  computed: {
    ...mapState(['isCollapse'])
  },
  methods: {
    // 获取申请的时候需要的数据
    getApplyDetail () {
      this.isLoading = true;
      this.contractNum &&
        getCeddChangeApplyDetail(this.contractNum)
          .then((res) => {
            let json = res.data;
            if (json.status === '200') {
              if (!this.isReSubmit) {
                this.$refs.customerScheduleChangeFilling.setDefaultFormData(
                  json.data
                );
                this.$refs.basicInformation.setDefaultFormData(json.data);
              }
              this.$refs.detailedInformation.setDefaultFormData(json.data);
              // T+7
              this.verificationDate = json.data.verificationDate;
              this.getDetailData();
            }
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    // 获取详情的时候需要的数据
    getDetailData () {
      this.applicationId &&
        getCeddChangeDetail(this.applicationId)
          .then((res) => {
            let json = res.data;
            if (json.status === '200') {
              // 没有权限送到详情
              if (!json.data.approveAuth) {
                this.$router.replace({
                  path: '/expectedDeliveryDateDetail',
                  query: {
                    applicationId: this.$route.query.applicationId
                  }
                });
              }
              this.handleChangeCeddType(json.data.form.type);
              this.$refs.customerScheduleChangeFilling.setDefaultFormData(
                json.data
              );
              this.$refs.basicInformation.setDefaultFormData(json.data);
              // 默认选择的
              this.$refs.detailedInformation.setDefaultSelection(
                json.data.detail
              );
            }
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    getParams () {
      const params = {};

      const { form, files } =
        this.$refs.customerScheduleChangeFilling.getFormData();
      if (!form || !files) return false;
      params.form = form;
      params.fileTokenList = files;
      params.base = this.$refs.basicInformation.getFormData();
      const detail = this.$refs.detailedInformation.getFormData();
      if (!detail) return false;
      params.detail = detail;
      return params;
    },
    // 提交
    handleSubmit () {
      const params = this.getParams();
      if (params) {
        this.isLoading = true;
        submitChangeApply(params)
          .then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.$message.success('提交成功');
              this.$router.replace({
                path: '/expectedDeliveryDateApplyList'
              });
            }
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    // 获取下拉
    getSelectList () {
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', {
        dictType: 'CEDD_CHANGE_TYPE',
        type: 'changeType'
      });
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', {
        dictType: 'CEDD_CHANGE_ADVANCE',
        type: 'changeAdvance'
      });
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', {
        dictType: 'CEDD_CHANGE_DELAY',
        type: 'changeDelay'
      });
    },
    handleChangeCeddType (value) {
      this.changeType = value;
    },
    handleCancel () {
      this.$router.replace({
        path: '/expectedDeliveryDateApplyList'
      });
    },
    totalCny (val) {
      this.tatolCny = val;
    }
  },
  mounted () {
    this.isReSubmit = Number(this.$route.query.isReSubmit || 0);
    if (this.isReSubmit === 1) {
      this.applicationId = this.$route.query.applicationId;
    }
    this.contractNum = this.$route.query.contractNum;

    this.getSelectList();
    this.getApplyDetail();
  }
};
</script>

<style lang="scss" scoped>
.expected-Delivery-date_apply {
  margin-bottom: 60px;
  font-size: 14px !important;
}
.expected-Delivery-date_apply {
  :deep(.el-input__inner::placeholder) {
    color: #a6a6a6 !important;
  }
  :deep(.rj-page-card) {
    min-width: 890px;
  }
}
</style>
